import React from 'react'
import PropTypes from 'prop-types'
import { useDrop } from 'react-dnd'
import { Grid } from '@mui/material'

const Droppable = ({ id, moveItem, children, ...restProps }) => {
  const [, drop] = useDrop(
    () => ({
      accept: 'card',
      drop: item => {
        if (item.id === 'back' || id === 'back') return
        moveItem(item.id, id, true)
      },
      hover: item => {
        if (item.id === 'back' || id === 'back') return
        if (item.id === id) return
        moveItem(item.id, id)
      },
    }),
    [id],
  )

  return (
    <Grid ref={drop} {...restProps}>
      {children}
    </Grid>
  )
}

Droppable.propTypes = {
  id: PropTypes.string.isRequired,
  moveItem: PropTypes.func,
  children: PropTypes.node.isRequired,
}

Droppable.defaultProps = {
  moveItem: () => {},
}

export default Droppable
